import service from '@/api/step';
import {handleError} from '@/state/generators/helpers';
import {loading, normalizeFilters} from "../generators/helpers";

// Lépésekhez kapcsolt státuszok cache-e szűrőnként, és a folyamatban lévő kérések.
// A `statuses` és az `allStatuses` ugyanazt a végpontot hívja, ezért közös a cache.
let statusesCache = {};
let statusesPending = {};
// Az utoljára kért kulcs mutációnként: csak ennek a válasza írhatja a state-et.
const lastStatusesKey = {};

const clone = (value) => JSON.parse(JSON.stringify(value ?? []));

const fetchStatuses = function ({commit, rootState}, payload, mutation) {
    const key = normalizeFilters(payload);

    lastStatusesKey[mutation] = key;

    if (statusesCache[key]) {
        const cached = clone(statusesCache[key]);
        commit(mutation, cached);
        return cached;
    }

    const apply = (data) => {
        if (lastStatusesKey[mutation] === key) {
            commit(mutation, clone(data));
        }
        return data;
    };

    if (statusesPending[key]) {
        return statusesPending[key].then(data => data === undefined ? data : apply(data));
    }

    loading(commit);

    const request = rootState.status.service.fetchAll(payload).then(response => {
        statusesCache[key] = clone(response.data);
        loading(commit, false);
        return response.data;
    }).catch((e) => {
        handleError(e, commit);
    }).finally(() => {
        if (statusesPending[key] === request) {
            delete statusesPending[key];
        }
    });

    statusesPending[key] = request;

    return request.then(data => data === undefined ? data : apply(data));
};

export const state = {
    stepsWithProjectStepsLoading: false,
    stepsWithProjectSteps: [],
    service: service('steps/projects'),
    statuses: [],
    allStatuses: [],
}

export const getters = {
    stepsWithProjectStepsLoading: function (state) {
        return !!state.stepsWithProjectStepsLoading
    },
    stepsWithProjectSteps: function (state) {
        return state.stepsWithProjectSteps
    },
    statuses: (state) => state.statuses,
    allStatuses: (state) => state.allStatuses
}

export const mutations = {
    'SET_STEPS_WITH_PROJECT_STEPS_LOADING': function (state, boolean = true) {
        state.stepsWithProjectStepsLoading = boolean
    },

    'SET_STEPS_WITH_PROJECT_STEPS': function (state, list) {
        state.stepsWithProjectSteps = list
    },

    'SET_STATUSES': function (state, list = []) {
        state.statuses = list
    },

    'SET_ALL_STATUSES': function (state, list = []) {
        state.allStatuses = list
    },

    'SET_STATUS_INITIATORS': function (state, {data, index}) {
        if (!state.item.status_initiators) {
            state.item.status_initiators = [];
        }
        if (index === false) {
            state.item.status_initiators.push(data);
        } else {
            state.item.status_initiators[index] = Object.assign(state.item.status_initiators[index], data);
        }
    },
}

export const actions = {
    steps: function ({commit, state}, filters) {
        commit('app/SET_LOADING', true, {root: true})
        commit('SET_STEPS_WITH_PROJECT_STEPS_LOADING', true)

        return state.service.fetchStepsWithProjectSteps(filters.project_id, filters).then(response => {
            commit('SET_STEPS_WITH_PROJECT_STEPS', response.data)
            commit('app/SET_LOADING', false, {root: true})
            commit('SET_STEPS_WITH_PROJECT_STEPS_LOADING', false)
            return response.data
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    clearStepsWithProjectSteps: function ({ commit }) {
        commit('SET_STEPS_WITH_PROJECT_STEPS',[])
    },

    statuses: function (context, payload) {
        return fetchStatuses(context, payload, 'SET_STATUSES');
    },

    allStatuses: function (context, payload) {
        return fetchStatuses(context, payload, 'SET_ALL_STATUSES');
    },

    clearStatusesCache: function () {
        statusesCache = {};
    },

    clearStatuses: function ({commit}) {
        lastStatusesKey['SET_STATUSES'] = null;
        commit('SET_STATUSES', [])
    },

    clearAllStatuses: function ({commit}) {
        lastStatusesKey['SET_ALL_STATUSES'] = null;
        commit('SET_ALL_STATUSES', [])
    },

    setStatusInitiators: function ({commit}, {data, index}) {
        commit('SET_STATUS_INITIATORS', {data: data, index: index === -1 ? false : index})
    },
}
